export enum EnumClaimAction {
  create = "create",
  edit = "edit",
  approve = "approve",
}
